import { Modal, Button, Card, Typography, Space } from 'antd';
import { 
  LockOutlined, 
  ExclamationCircleOutlined, 
  CustomerServiceOutlined,
  CheckCircleOutlined 
} from '@ant-design/icons';
import { motion } from 'framer-motion';

const { Title, Text, Paragraph } = Typography;

interface RestrictedAccessModalProps {
  show: boolean;
  onHide: () => void;
}

const RestrictedAccessModal: React.FC<RestrictedAccessModalProps> = ({ show, onHide }) => {
  return (
    <Modal
      title={
        <Space>
          <LockOutlined style={{ color: '#ff4d4f' }} />
          <span>Accès restreint</span>
        </Space>
      }
      open={show}
      onCancel={onHide}
      footer={null}
      width={650}
      centered
      closable={true}
      className="restricted-access-modal"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Card 
          bordered={false}
          style={{ 
            background: 'linear-gradient(135deg, #fff9f9 0%, #fff 100%)',
            borderLeft: '4px solid #ff4d4f'
          }}
        >
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
              <ExclamationCircleOutlined 
                style={{ 
                  fontSize: 40, 
                  color: '#ff4d4f',
                  marginTop: 4
                }} 
              />
              <div>
                <Title level={4} style={{ color: '#d9534f', marginBottom: 8 }}>
                  ❗ Accès temporairement restreint
                </Title>
                <Paragraph style={{ color: '#666', fontSize: '15px', lineHeight: 1.6 }}>
                  Vous n'êtes pas encore autorisé à accéder à cette fonctionnalité.
                  <br />
                  La création de facturation est réservée aux utilisateurs dont le compte a été validé par l'administrateur.
                </Paragraph>
              </div>
            </div>
          </Space>
        </Card>

        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          gap: 12, 
          marginTop: 24 
        }}>
          <Button 
            onClick={onHide}
            style={{
              borderRadius: '6px',
              padding: '8px 24px',
              height: 'auto',
              background: '#4BB0C0',
              border: 'none',
              color: '#fff'

            }}
          >
            Compris
          </Button>
          {/* <Button 
            type="primary"
            onClick={onHide}
            style={{
              borderRadius: '6px',
              padding: '8px 24px',
              height: 'auto',
              background: 'linear-gradient(135deg, #4BB0C0 0%, #2a8d9c 100%)',
              border: 'none'
            }}
            icon={<CustomerServiceOutlined />}
          >
            D'ACCORD
          </Button> */}
        </div>
      </motion.div>
    </Modal>
  );
};

const modalStyles = `
  .restricted-access-modal .ant-modal-header {
    background: linear-gradient(135deg, #fff9f9 0%, #fff 100%);
    border-bottom: 1px solid #ffcccc;
  }
  
  .restricted-access-modal .ant-modal-title {
    color: #d9534f;
    font-weight: 600;
  }
  
  .restricted-access-modal .ant-modal-close {
    color: #ff4d4f;
  }
  
  .restricted-access-modal .ant-modal-close:hover {
    color: #d9363e;
    background-color: #fff9f9;
  }
`;


<style>{modalStyles}</style>

export default RestrictedAccessModal;